import { createContext, useContext } from 'react';

type CandidateExplanations = {
  explanationsById: Record<string, string | null>;
  pendingIds: Set<string>;
};

const EMPTY: CandidateExplanations = {
  explanationsById: {},
  pendingIds: new Set()
};

// Kept out of rowData: without `getRowId`, new rows rebuild the whole grid.
export const CandidateExplanationsContext =
  createContext<CandidateExplanations>(EMPTY);

export const useCandidateExplanation = (candidateProfileId?: string) => {
  const { explanationsById, pendingIds } = useContext(
    CandidateExplanationsContext
  );

  if (!candidateProfileId) return { explanation: null, loading: false };

  return {
    explanation: explanationsById[candidateProfileId] ?? null,
    loading: pendingIds.has(candidateProfileId)
  };
};
